// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m81m1scRTu4kVR6IaWB7{padding:0 44px;overflow-x:hidden;overflow-y:auto}.O0s8_COJu3gb38ydZvOw{flex-direction:column;flex:1;justify-content:center;width:100%;max-width:760px;margin:0 auto;padding:0 16px;display:flex}.O0s8_COJu3gb38ydZvOw .B4923hi10nM9l4d2lITM{flex-direction:column;display:flex}.O0s8_COJu3gb38ydZvOw .zScGD3LBZ0bK_ebQsf1Y{border-radius:16px;align-items:flex-end;min-height:276px;margin-bottom:32px;display:flex;overflow:hidden}.O0s8_COJu3gb38ydZvOw .zScGD3LBZ0bK_ebQsf1Y img{width:100%;max-width:492px;height:auto;display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `m81m1scRTu4kVR6IaWB7`,
	"empty": `O0s8_COJu3gb38ydZvOw`,
	"title": `B4923hi10nM9l4d2lITM`,
	"titlePreview": `zScGD3LBZ0bK_ebQsf1Y`
};
export default ___CSS_LOADER_EXPORT___;
